module.exports = {
          srcSet: __webpack_public_path__ + "571e70f4affc8eff5daffe177a3c8329-459.png"+" 459w",
          images:[ {path: __webpack_public_path__ + "571e70f4affc8eff5daffe177a3c8329-459.png",width: 459,height: 587}],
          src: __webpack_public_path__ + "571e70f4affc8eff5daffe177a3c8329-459.png",
          toString:function(){return __webpack_public_path__ + "571e70f4affc8eff5daffe177a3c8329-459.png"},
          
          width: 459,
          height: 587
        }